import { createElement } from "react";
import { createRoot, type Root } from "react-dom/client";
import { sleep } from "@/canv/utils";
import { ProgressBarLayout } from "./ProgressBarLayout";
import styles from "./progressBar.module.css";

export class ProgressBar {
    async show() {
        const progressBar = document.createElement("div");

        progressBar.classList.add(styles.progressBar);
        this.progressBar = progressBar;

        document.body.prepend(progressBar);

        this.root = createRoot(progressBar);
        this.render();

        await sleep(530);

        this.filler = document.getElementsByClassName(
            styles.progressBarInnerFiller,
        )[0] as HTMLDivElement;
        this.timer = setInterval(this.sync.bind(this), 60);
    }

    render() {
        const ProgressBarLayoutElement = createElement(ProgressBarLayout);

        if (this.root) {
            this.root.render(ProgressBarLayoutElement);
        } else {
            throw new Error("ProgressBar can't find this.root");
        }
    }

    async hide() {
        this.moveTo(100);
        await sleep(250);

        this.root?.unmount();
        this.progressBar?.parentNode?.removeChild(this.progressBar);

        if (this.timer) {
            clearInterval(this.timer);
        }
    }

    moveTo(perc: number) {
        this.state = perc;
    }

    sync() {
        if (this.filler) {
            this.filler.style.width = `${this.state}%`;
        }
    }

    timer: NodeJS.Timeout | null = null;
    filler: HTMLDivElement | null = null;
    root: Root | null = null;
    progressBar: HTMLDivElement | null = null;
    state = 0;
}
